/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:tasks-pilet:data-source */

export interface DataSourceBlockParams {
	/**
	 * The container RID for finding all tasks in a resource.
	 */
	containerRID: string;
	/**
	 * An object where keys are field names and values are sorting orders.
	 */
	sort?: {
		[k: string]: 'asc' | 'desc';
	};
	/**
	 * An object where keys are field names and values are either simple strings or objects with advanced filtering operators.
	 */
	filter?: {
		[k: string]:
			| string
			| {
					$eq?: string;
					$ne?: string;
					$gt?: string;
					$gte?: string;
					$lt?: string;
					$lte?: string;
					$starts?: string;
			  };
	};
	/**
	 * Number of resources to skip as part of the paged operation.
	 */
	skip?: number;
	/**
	 * Number of resources to retrieve as part of the paged operation.
	 */
	limit?: number;
	/**
	 * Boolean to indicate listing all descendants of the container if true or listing first level children of the container if false. Defaults to false.
	 */
	recursive?: boolean;
}
/** Zone parameters for urn:zone:tasks-pilet:data-source:children */

export interface DataSourceChildrenZoneParams {}
/** Contract Data for urn:zone:tasks-pilet:data-source:children */

export interface DataSourceChildrenContractData {
	resources?: LoadedTaskSchema[];
}
export interface LoadedTaskSchema {
	name: string;
	title: string;
	description?: string;
	dueDate?: string;
	assignee: string;
	status: string;
	RID: string;
	createdAt?: string;
	updatedAt?: string;
	creatorRID?: string;
	lifecycleState?: string;
	updaterRID?: string;
	/**
	 * Optional custom fields injected at runtime
	 */
	properties?: {
		[k: string]: unknown;
	};
}
/** Block parameters for urn:block:tasks-pilet:task-detail */

/**
 * Fetches task details by taskRID and provides them to the rest of the view.
 */
export interface TaskDetailBlockParams {
	/**
	 * The task RID for finding the task detail.
	 */
	taskRID: string;
}
/** Zone parameters for urn:zone:dynamic-components:task-detail:children */

export interface TaskDetailChildrenZoneParams {}
/** Contract Data for urn:zone:dynamic-components:task-detail:children */

export interface TaskDetailChildrenContractData {
	taskDetails?: {};
}

export namespace BlockNames {
	export const DataSource = 'urn:block:tasks-pilet:data-source' as const;
	export type DataSource = 'urn:block:tasks-pilet:data-source';
	export const TaskDetail = 'urn:block:tasks-pilet:task-detail' as const;
	export type TaskDetail = 'urn:block:tasks-pilet:task-detail';
}

export namespace ZoneTypes {
	export const DataSourceChildren = 'urn:zone:tasks-pilet:data-source:children' as const;
	export type DataSourceChildren = 'urn:zone:tasks-pilet:data-source:children';
	export const TaskDetailChildren =
		'urn:zone:dynamic-components:task-detail:children' as const;
	export type TaskDetailChildren = 'urn:zone:dynamic-components:task-detail:children';
}

export type DataSourceProps = ShellProps & BlockParams & DataSourceBlockParams;
export type TaskDetailProps = ShellProps & BlockParams & TaskDetailBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:tasks-pilet:data-source']: BlockParams & DataSourceBlockParams;
		['urn:block:tasks-pilet:task-detail']: BlockParams & TaskDetailBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:tasks-pilet:data-source:children']: DataSourceChildrenZoneParams;
		['urn:zone:dynamic-components:task-detail:children']: TaskDetailChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:tasks-pilet:data-source:children']: DataSourceChildrenContractData;
		['urn:zone:dynamic-components:task-detail:children']: TaskDetailChildrenContractData;
	}
}
